import React from 'react';
import { ShieldAlert } from 'lucide-react';

// Yönetici üyeyi yatırım veya çekime kapattığında hesap açık kalır; sayfa da
// menüden kaybolmaz. Oyuncu tıkladığında içerik yerine bu bilgi çizilir —
// başka bir sayfaya yönlendirmek "sayfa yok" gibi görünüp destek hattını
// gereksiz meşgul ediyordu.
const AccessBlockedNotice = ({ title, description }) => (
  <div className="pusu-panel mx-auto max-w-xl p-6 text-center sm:p-8">
    <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-red-500/10 text-red-400">
      <ShieldAlert size={32} aria-hidden="true" />
    </div>
    <div className="text-lg font-bold text-white">{title}</div>
    <p className="mt-2 text-sm text-gray-400">{description}</p>
    <p className="mt-4 text-xs text-gray-500">
      Kısıtın kaldırılması için müşteri hizmetleri ile iletişime geçebilirsiniz.
    </p>
  </div>
);

export default AccessBlockedNotice;
